import React from 'react';
import StatCard from '../components/dashboard/StatCard';
import PipelineChart from '../components/dashboard/PipelineChart';
import MostAppliedPositions from '../components/dashboard/MostAppliedPositions';
import RecentApplications from '../components/dashboard/RecentApplications';
import SafeIcon from '../common/SafeIcon';

const Dashboard = () => {
  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-2">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">Job Dashboard</h1>
          <p className="text-gray-500">Overview of your hiring and recruitment metrics.</p>
        </div>
        <div className="flex gap-3">
          <button className="px-4 py-2 bg-white border border-gray-200 text-gray-600 rounded-lg hover:bg-gray-50 transition-colors shadow-sm flex items-center gap-2 font-medium">
            <SafeIcon name="Filter" size={18} />
            Filters
          </button>
          <button className="btn-primary flex items-center gap-2">
            <SafeIcon name="Plus" size={18} />
            Post New Job
          </button>
        </div>
      </div>

      {/* Top 4 Stats Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        <StatCard 
          title="Total Positions" 
          value="1,240" 
          icon="Briefcase" 
          trend="up" 
          trendValue="12.5%" 
          colorClass="bg-brand-primary/10 text-brand-primary"
          delay={0.1}
        />
        <StatCard 
          title="Active Positions" 
          value="84" 
          icon="Zap" 
          trend="up" 
          trendValue="5.2%" 
          colorClass="bg-brand-secondary/10 text-brand-secondary"
          delay={0.2}
        />
        <StatCard 
          title="Applications" 
          value="12,560" 
          icon="FileText" 
          trend="up" 
          trendValue="18.4%" 
          colorClass="bg-green-100 text-green-600"
          delay={0.3}
        />
        <StatCard 
          title="Candidates" 
          value="5,420" 
          icon="Users" 
          trend="down" 
          trendValue="2.1%" 
          colorClass="bg-purple-100 text-purple-600"
          delay={0.4}
        />
      </div>

      {/* Pipeline & Top Positions */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <PipelineChart />
        <MostAppliedPositions />
      </div>

      {/* Recent Applications Table (Full Width) */}
      <div className="grid grid-cols-1 gap-6">
        <RecentApplications />
      </div>
    </div>
  );
};

export default Dashboard;